import { createContext, useState, ReactNode } from 'react';
import { lockScroll } from '@/core/helpers';
import {
  activeCompanySelector,
  userSelector,
} from '@/core/store/user/userSlice';
import { useAppSelector } from '@/hooks';
import { PricingModelEnum, RolesEnum } from '@/core/enums';

const DEFAULT_LINK =
  'https://vat.countx.com/meetings/cornelius/beratungsgesprach-mit-team-sales';

export const BookMeetingModalContext = createContext<{
  isModalOpened: boolean;
  closeModal: () => void;
  openModal: (v?: string) => void;
  link: string;
}>({
  isModalOpened: false,
  closeModal: () => {},
  openModal: () => {},
  link: '',
});

export function HubspotBookMeetingModalWrapper({
  children,
}: {
  children: ReactNode;
}) {
  const [isModalOpened, setIsModalOpened] = useState(false);
  const [link, setLink] = useState(DEFAULT_LINK);
  const user = useAppSelector(userSelector);
  const activeCompany = useAppSelector(activeCompanySelector);

  const closeModal = () => {
    setIsModalOpened(false);
    lockScroll(false);
  };

  const openModal = (v?: string) => {
    let link = DEFAULT_LINK;

    if (
      user?.Role === RolesEnum.SELLER &&
      activeCompany?.Clerk?.HubspotMeetingLink
    ) {
      link = activeCompany?.Clerk?.HubspotMeetingLink;
    }

    if (
      user?.Role === RolesEnum.TAX_ADVISOR &&
      (activeCompany?.PricingModel === PricingModelEnum.Core ||
        activeCompany?.PricingModel === PricingModelEnum.JTLIncludingOSSSeSe)
    ) {
      link = 'https://meetings-eu1.hubspot.com/niels-van-katwijk';
    }

    setLink(v || link);
    setIsModalOpened(true);
    lockScroll(true);
  };

  return (
    <BookMeetingModalContext.Provider
      value={{
        isModalOpened,
        closeModal,
        openModal,
        link,
      }}
    >
      {children}
    </BookMeetingModalContext.Provider>
  );
}
